import React, { useState, useEffect } from 'react';
import { Save, X } from 'lucide-react';

const RoadmapLevelModal = ({ showModal, onClose, onSubmit, initialData }) => {
  const [name, setName] = useState('');
  const [subtitle, setSubtitle] = useState('');
  const [description, setDescription] = useState('');
  const [order, setOrder] = useState('');

  useEffect(() => {
    if (showModal) {
      if (initialData) {
        // Pre-fill form fields for editing existing level
        setName(initialData.name || '');
        setSubtitle(initialData.subtitle || '');
        setDescription(initialData.description || '');
        setOrder(initialData.order !== undefined ? initialData.order.toString() : '');
      } else {
        // Reset form fields for adding a new level
        setName('');
        setSubtitle('');
        setDescription('');
        setOrder('');
      }
    }
  }, [showModal, initialData]);

  const handleSubmit = () => {
    if (!name.trim() || !order) {
      console.error('Please fill out all required fields.');
      return;
    }

    onSubmit({
      id: initialData?.id, // Pass the ID if it exists for updates
      name,
      subtitle,
      description,
      order: parseInt(order),
    });
  };

  if (!showModal) {
    return null;
  }

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-slate-800 rounded-xl max-w-md w-full p-6 text-white border border-slate-700">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-xl font-bold">{initialData ? 'Edit Level' : 'Add New Level'}</h2>
          <button
            onClick={onClose}
            className="p-2 hover:bg-slate-700 rounded-lg"
          >
            <X className="w-5 h-5 text-slate-400" />
          </button>
        </div>
        <div className="space-y-4">
          <div>
            <label className="text-start block text-sm font-medium text-slate-300 mb-1">Level Name</label>
            <input
              type="text"
              value={name}
              onChange={(e) => setName(e.target.value)}
              className="w-full p-2 bg-slate-700 border border-slate-600 rounded-md text-white placeholder-slate-400"
              placeholder="Enter title"
            />
          </div>
          <div>
            <label className="text-start block text-sm font-medium text-slate-300 mb-1">Subtitle</label>
            <input
              type="text"
              value={subtitle}
              onChange={(e) => setSubtitle(e.target.value)}
              className="w-full p-2 bg-slate-700 border border-slate-600 rounded-md text-white placeholder-slate-400"
              placeholder="Enter subtitle"
            />
          </div>
          <div>
            <label className="text-start block text-sm font-medium text-slate-300 mb-1">Description</label>
            <textarea
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full p-2 bg-slate-700 border border-slate-600 rounded-md text-white placeholder-slate-400"
              rows="3"
              placeholder="Enter description"
            ></textarea>
          </div>
          <div>
            <label className="text-start block text-sm font-medium text-slate-300 mb-1">Order</label>
            <input
              type="number"
              value={order}
              onChange={(e) => setOrder(e.target.value)}
              className="w-full p-2 bg-slate-700 border border-slate-600 rounded-md text-white placeholder-slate-400"
              placeholder="e.g, 1, 2, 3..."
            />
          </div>
          <button
            onClick={handleSubmit}
            className="w-full py-2 bg-blue-600 hover:bg-blue-700 rounded-lg text-white font-medium flex items-center justify-center gap-2"
          >
            <Save className="w-5 h-5" /> {initialData ? 'Save Changes' : 'Add Level'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RoadmapLevelModal;
